<span [class]="'avatar' + ' ' + fromSizeAvatar(sizeAvatar) + ' ' +  fromRoleAvatar(roleAvatar)">
    <ng-content></ng-content>
</span>
